import React from 'react';

/** Shimmer placeholder used in place of plain "Loading…" text. */
export const Skel: React.FC<{
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
}> = ({ width, height, className, style }) => (
  <span
    className={`hf-skel line${className ? ` ${className}` : ''}`}
    style={{ width, height, ...style }}
    aria-hidden="true"
  />
);

/** KPI card placeholder — mirrors the .hf-kpi layout. */
export const SkelKpi: React.FC = () => (
  <div className="hf-kpi">
    <Skel width="50%" />
    <span className="hf-skel kpi-value" aria-hidden="true" />
    <span className="hf-skel kpi-sub" aria-hidden="true" />
  </div>
);

/** Single shimmer row for an hf-table. cols controls the number of cells. */
export const SkelRow: React.FC<{ cols: number; numCols?: number[] }> = ({ cols, numCols = [] }) => (
  <tr className="hf-skel-row" aria-hidden="true">
    {Array.from({ length: cols }).map((_, i) => (
      <td key={i} className={numCols.includes(i) ? 'num' : undefined}>
        <span className="hf-skel" />
      </td>
    ))}
  </tr>
);
